function escapeHtml(value) {
  // return value.replace(/[&<>"'`=\/]/g, (char) => {
  //     const map = {
  //         '&': '&amp;',
  //         '<': '&lt;',
  //         '>': '&gt;',
  //         '"': '&quot;',
  //         "'": '&#39;',
  //         '`': '&#96;',
  //         '=': '&#61;',
  //         '/': '&#47;',
  //     };

  //     return map[char] || char;
  // });
  return value.replace(/[&<>"'`=\/]/g, '');
}

export function sanitizeString(input) {
    if (typeof input !== 'string') {
        return '';
    }
    const trimmed = input; //.trim();
    const noTags = trimmed.replace(/<[^>]*>/g, '');
    const noControl = noTags.replace(/[\u0000-\u001F\u007F]/g, '');

    return escapeHtml(noControl);
}